export default {
    message: {
        currencySymbol: "$",
        currencyDesc: "USD",
        tiers: {
            t1: {
                label: "Workspace Standard",
                desc: "<p>Tek oturum açma (SaaS), web uygulamaları ve dosya paylaşım hizmetlerini kullanan modern çalışanlar için akıllı özelliklere sahip Çekirdek Çalışma Alanı.</p><p>Tüm uygulamalar için çok faktörlü kimlik doğrulama desteği ile tek oturum açma (SSO) içerir; mikro uygulamalar, kişiselleştirilmiş beslemeler ve sanal yardım ile çalışma alanı istihbaratı; dahası sınırsız dosya depolama özelliğine sahip Citrix Content Collaboration Standard hizmeti.</p>"
            },
            t2: {
                label: "Workspace Premium",
                desc: "<p>Granüler güvenlikle tam bir dijital çalışma alanına ihtiyaç duyan, ancak sanal uygulamalar ve masaüstleri gerektirmeyen çalışanlar için eksiksiz çalışma alanı çözümü.</p><p>Workspace Standard özelliklerinin yanı sıra SaaS ve web için gelişmiş güvenlik kontrolleri, bütünleştirilmiş uç nokta yönetimi ve Content Collaboration Premium içerir.</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                desc: "<p>Citrix Virtual Apps and Desktops için karma dağıtım seçenekleri içeren kapsamlı çalışma alanı çözümü.</p><p>Workspace Premium özelliklerinin yanı sıra Citrix Virtual Apps and Desktops için bir bulut yönetimi seçeneğini içerir.</p>"
            },
            t4: {
                label: "Workspace Essentials",
                desc: "<p>Citrix Workspace Essentials, küçük ve orta ölçekli işletmelerin tek oturum açma (SaaS) ve web uygulamalarında oturum açma işlemini basitleştirip güvence altına alarak verilerini korumalarına yardımcı olur.</p><p>Oturum açma işleminin daha da güvenli olmasını sağlamak için SaaS ve web uygulamalarında çoklu faktör kimlik doğrulaması ile tek oturum açma özelliği içerir ve hesabın tehlikeye girme olasılığını %99,9 oranında azaltmaya yardımcı olur.</p>"
            },
            terms: "*Kullanıcı başına, aylık",
            btn1: "Özellik matrisini görüntüle"
        },
        features: {
            disclaimer1: "*Üreticinin Önerdiği Perakende Fiyatı, 3 yıllık abonelikle 500 kullanıcı için kullanıcı başına USD cinsinden aylık ortalama fiyattır. Gerçek fiyatlandırma farklı olabilir.<br /> Citrix Workspace lisanslama seçenekleri 25 kullanıcıdan başlar.",
            disclaimer2: "**Workspace Premium hizmeti, kurum içi Citrix Virtual Apps and Desktops kurulumları için Workspace Analytics’i kapsamaz."
        },
        calculator: {
            edition: "Sürümünüzü seçin",
            title: "Fiyatlandırmanızı hesaplayın",
            users: "Kullanıcılarınızı seçin",
            estCost: "Tahmini aylık masrafınız",
            btn1: "Bir uzmanla konuşun",
            btn1_link: "/products/citrix-workspace/form/pricing-inquiry/",
            minUserMsg: "Lisanslama seçenekleri 25 kullanıcıdan başlar. Lütfen tekrar deneyin.",
            lowUserMsg: "Kullanıcı sayınız 500’den az mı? Küçük veya orta ölçekli işletme ihtiyaçlarınız için size yardımcı olabiliriz.",
            volumeDiscount: "Kullanıcı sayınız 2500’den fazla mı? İndirimli hacim fiyatlandırmasının keyfini çıkarın.",
            contract1: "1 yıllık sözleşme",
            contract3: "3 yıllık sözleşme",
            contract3savings: "%20 tasarruf",
            term: "Kullanıcı başına, aylık",
            disclaimer: "*Bu hesaplayıcı size tahmini bir fiyat verir ve yalnızca bütçe oluşturma amacıyla kullanılır. Gerçek fiyatlar değişkenlik gösterebilir. Geçerli indirimler için Citrix ekibinize veya iş ortağınıza ulaşın."
        },
        stats: {
            title: "Avantajlarınız",
            stat1: {
                title: "Çalışan deneyimini iyileştirin.",
                desc: "<b>5 BT liderinden 4'ü</b> çalışan deneyiminin dijital dönüşümleri için kritik önem taşıdığına inanıyor."
            },
            stat2: {
                title: "Çalışanlarınıza seçenek sunun",
                desc: "İş dünyası liderlerinin <b>%78’i</b>, çalışanların kullandığı uygulamaları ve cihazları seçebilmelerinin çalışan deneyimini geliştirmeye yardımcı olduğunu kabul ediyor."
            },
            stat3: {
                title: "Erişimi basitleştirin",
                desc: "İş dünyası liderlerinin <b>%47’si</b> çalışanların katılımına en büyük katkının, işin yapılması için gereken bilgilere erişim kolaylığı olduğunu söylüyor."
            },
            btn1: "Bir uzmanla konuşun",
            disclaimer: "Kaynak: <a href='https://theexperienceofwork.economist.com/Citrix_The_Experience_of_Work_BriefingPaper.pdf' target='_blank'>The Economist</a>"
        }
    }
}